export default {

    /**
     * 是否为手机号码
     * @param {Object} num
     */
    isMobile: function(num) {
        //var reg = /^(13[0-9]|15[0-9]|17[0-9]|18[0-9]|14[57])\d{8}$/;
        var reg = /^\d{11}$/;
        return reg.test(num);
    },
    isGuangdiantongChannel: function(channelid) {
        // 1030512002
        var reg = /\d{1}03\d{7}/;
        return reg.test(channelid);
    },
    isSuozhiChannel: function(channelid) {
        //_13_______
        var reg = /\d{1}13\d{7}/;
        return reg.test(channelid);
    },
    isNewChannel: function(channelid) {
        var newChannels = ["1050528003", "1020526004", "1050528004", "2080123001", "2120123001", "1050528001", "1140510007", "1020526001", "2050128001", "1020526002", "2080110002", "2120127002", "2050120001", "1020526005", "1050528002", "1020526003", "3050228001", "1010715010", "1050529005", "1050515022", "1030516026", "1050610020", "1050515020", "1050529003", "1050529004", "1050529005", "1050529003", "1050529004", "2050129001", "1050529006", "3050229001", "1050529001", "1050529002", "1010516024", "1050523006", "1030518010", "1050523005", "1050528006", "1050528007", "1010516025", "1010715007", "1050515023", "1050523002", "2050129001", "1050521006", "1050610019", "1050523001", "1010715009", "1050528005", "1010715008", "1030518011", "1010715011", "1050529001", "1010518017", "1050521005", "3050223001", "1010516026", "1050515021", "1050523003", "1050529002", "1050523004", "2050123001", "1050521007", "1030516027", "1050610021"]
        return newChannels.indexOf(channelid) > -1;
    },
    isKAChannel: function(channelid) {
        var newChannels = ["3050229003", "1050529005", "1050529010", "1050529011", "1050529003", "1050529004", "1050529014", "1050529007", "1050529009", "2050129001", "1050529006", "3050229001", "1050529001", "3050229002", "1050529013", "1050529012", "1050529002", "1050529008", "3050229004", "1050531004", "3050231001", "1050531002", "1050531005", "1050531003", "1050531009", "2050131001", "1050531008", "1050531001", "1050531007", "1050531006", "1050610014", "1050521012", "1050528002", "1050523007", "1050523002"]
        return newChannels.indexOf(channelid) > -1;
    },
    isKuaishouChuangyan: function(channelid) {
        var reg = /\d{1}02\d{2}26\d{3}/;
        return reg.test(channelid);
    },
    isTuiaChannel: function(channelid) {
        // _05__06___
        var reg = /\d{1}05\d{7}/;
        return reg.test(channelid);
    },
    isToutiaoChannel: function(channelid) {
        // _01_______
        var reg = /\d{1}01\d{7}/;
        return reg.test(channelid);
    },
    /**
     * 判断传入的内容是否为空
     * @param {Object} content
     */
    isEmpty: function(content) {
        if (content != null && content != "" && content != "undefined" && content != "null" && content != "unknown") {
            return false;
        } else {
            return true;
        }
    },
    /**
     * 获取链接参数
     * @param {Object} name
     */
    getQueryString: function(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return unescape(decodeURI(r[2]));
        }
        return null;
    },
    //获取广告平台唯一id
    getAdvertId: function() {
        var aOld = this.getQueryString('a_oId') ? this.getQueryString('a_oId') : '';
        var clickid = this.getQueryString('clickid') ? this.getQueryString('clickid') : '';
        var trackId = this.getQueryString('track_id') ? this.getQueryString('track_id') : '';
        var callbackUrl = this.getQueryString('callback_url') ? this.getQueryString('callback_url') : (this.getQueryString('callback') ? this.getQueryString('callback') : '');
        var callbackParam = this.getQueryString('callback_param') ? this.getQueryString('callback_param') : '';
        var bxmId = this.getQueryString('bxm_id') ? this.getQueryString('bxm_id') : '';
        var advertId = this.getQueryString('advert_id') ? this.getQueryString('advert_id') : '';
        var gdtId = this.getQueryString('qz_gdt') ? this.getQueryString('qz_gdt') : (this.getQueryString('gdt_vid') ? this.getQueryString('gdt_vid') : '');
        var xmobId = this.getQueryString('userkey') ? this.getQueryString('userkey') + '|' + this.getQueryString('plid') : '';
        var jcId = this.getQueryString('jcid') ? this.getQueryString('jcid') : '';
        var bdId = this.getQueryString('bd_vid') ? this.getQueryString('bd_vid') : '';
        var oId = this.getQueryString('oId') ? this.getQueryString('oId') : '';
        var searchId = this.getQueryString('searchId') ? this.getQueryString('searchId') : '';
        var landingid = this.getQueryString('landingid') ? this.getQueryString('landingid') : '';
        var szRli = this.getQueryString('sz_rli') ? this.getQueryString('sz_rli') : '';
        var nadKey = this.getQueryString('nadkey') ? this.getQueryString('nadkey') : '';
        var qcjParamStr = this.getQueryString('qcjParamStr') ? this.getQueryString('qcjParamStr') : '';
        var clickTag = this.getQueryString('click_tag') ? this.getQueryString('click_tag') : '';
        var adClick = this.getQueryString('bcx_cli') ? this.getQueryString('bcx_cli') : '';
        var basicPara = this.getQueryString('basic_para') ? this.getQueryString('basic_para') : '';
        var ccbid = this.getQueryString('ccbid') ? this.getQueryString('ccbid') : '';
        var requestId = this.getQueryString('requestId') ? this.getQueryString('requestId') : '';
        var adExposureId = this.getQueryString('adExposureId') ? this.getQueryString('adExposureId') : '';
        var qhclickid = this.getQueryString('qhclickid')? this.getQueryString('qhclickid') : '';
        return aOld + clickid + trackId + callbackUrl + callbackParam + bxmId + advertId + gdtId + xmobId + jcId + bdId + oId + searchId + landingid + szRli + nadKey + qcjParamStr + clickTag + adClick + basicPara + ccbid + requestId + adExposureId + qhclickid;
    },
    getUnionSite: function() {
        var unionSite = this.getQueryString("union_site") ? this.getQueryString("union_site") : '';
        var appId = this.getQueryString("promoted_object_id") ? this.getQueryString("promoted_object_id") : '';
        return unionSite + appId;
    },

    getBaseUrl() {
        var urlString = window.location.href;
        if (urlString.startsWith('https://qiaos.gzjxwlkj.cn')) {
            return 'https://qiaos.gzjxwlkj.cn/qiaosi';
        } else if (urlString.startsWith('https://szyxb31.xwtec.cn')) {
            return 'https://szyxb31.xwtec.cn/qiaosi';
        } else if (urlString.startsWith('https://qiaos.zhonglianhuashu.com')) {
            return 'https://qiaos.zhonglianhuashu.com/qiaosi';
        } else if (urlString.startsWith('https://rz1014.laidianbanlv.cn')) {
            return 'https://rz1014.laidianbanlv.cn/qiaosi';
        } else if (urlString.startsWith('https://kh1208.laidianbanlv.cn/')) {
            return 'https://kh1208.laidianbanlv.cn/qiaosi';
        } else if (urlString.startsWith('https://qs101.banlianghao.com')) {
            return 'https://qs101.banlianghao.com/qiaosi'
        } else {
            return 'http://47.119.164.132:8080/qiaosi';
        }
    },
    getHost() {
        var urlString = window.location.href;
        var index = urlString.indexOf("/", 10);
        return urlString.substring(0, index + 1);
    },
    setCookieTime: function(key, value, time) {
        value = this.setEscape(value);
        var exp = new Date();
        exp.setTime(exp.getTime() + time * 60000);
        document.cookie = key + "=" + value + ";expires=" + exp.toGMTString() + ";path=/";
    },
    setEscape: function(content) {
        return encodeURI(content);
    },
    getUuid: function() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (Math.random() * 16) | 0,
                v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
}


// WEBPACK FOOTER //
// ./src/common/js/baseMethod.js